import React from "react";
import { Col, Row } from "react-bootstrap";
import { SiMysql, SiPostgresql, SiMongodb, SiOracle, SiNeo4J } from "react-icons/si";
import AWS from "../../Assets/TechIcons/AWS.svg";

function DatabasesStack() {
    return (
        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
            <Col xs={4} md={2} className="tech-icons">
                <SiMysql className="tech-icon-images" />
                <div className="tech-icons-text">MySQL</div>
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <SiPostgresql className="tech-icon-images" />
                <div className="tech-icons-text">PostgreSQL</div>
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <SiMongodb className="tech-icon-images" />
                <div className="tech-icons-text">MongoDB</div>
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <img src={AWS} alt="AWS" className="tech-icon-images" />
                <div className="tech-icons-text">Amazon AWS</div>
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <SiOracle className="tech-icon-images" />
                <div className="tech-icons-text">Oracle APEX</div>
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <SiNeo4J className="tech-icon-images" />
                <div className="tech-icons-text">Neo4j</div>
            </Col>
        </Row>
    );
}

export default DatabasesStack;
